import { FormField } from "./FormField";

export const InputField = (props) => <FormField {...props} />;
